module.exports = __webpack_public_path__ + "static/img/xaml.af9d85c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/xaml.png
// module id = H0OM
// module chunks = 53